// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#app[data-v-42c44c43]{width:100vw;min-height:100vh}#app .app-container[data-v-42c44c43]{width:100%;min-height:100%;overflow:hidden;display:flex;align-items:stretch;justify-content:flex-start;flex-wrap:nowrap;flex-direction:column}#app .app-container_router[data-v-42c44c43]{flex:1;width:100%}#app .app-container_router[data-v-42c44c43]::-webkit-scrollbar{display:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
